<template>
  <span ref="trigger">
    <slot></slot>
    <transition :name="effect">
      <div ref="popover" v-if="show" :class="['popover',placement]">
        <div class="arrow"></div>
        <h3 class="popover-title" v-if="title"><slot name="title">{{title}}</slot></h3>
        <div class="popover-content" v-if="content">
            <slot name="content">
                <span v-html="content"></span>
                <hr style="margin: 10px 0px 15px 0px;">

                <input-w v-model="dataModelObject" validation="required" @validateResult="checkValidateResult"
                :validateOnValueChange="true" :valueProp="fieldValue" :aIconStyle="{bottom: '22px', right: '10px'}">
                    <v-select :label="label" :options="choices" v-model="dataModelObject" :placeholder="placeholder">
                    </v-select>
                </input-w> 
            </slot>
        </div>
        <div>
            <button class="btn btn-danger btn-sm" style="float: left; margin: 5px" @click="cancel">Cancel</button>
            <button class="btn btn-primary-default btn-sm" style="float: right; margin: 5px" @click="apply" :disabled="invalid">Apply</button>
        </div>  
      </div>
    </transition>
  </span>
</template>

<script>
import PopoverMixin from './utils/popoverMixins.js'
import InputW from '../inputWrapper/inputWrapper.vue'
import vSelect from "../../dynamic/vueSelectWrapper/components/Select.vue"

export default {
  mixins: [PopoverMixin],
  props: {
    trigger: {
        type: String, 
        default: 'click'
    },
    title: String,
    content: String,
    value: String,
    validation: String,
    placeholder: String,
    fieldValue: {
      type: String,
      required: true
    },
    fieldLabel: String,
    choices: Array
  },
  components: {
    InputW,
    vSelect
  },
  data: function(){
      return {
          popoverCondition: true,
          dataModel: null,
          dataModelObject: {},
          invalid: true,
          label: null
      }
  },
  mounted: function(){
      this.setObjectFromValue();
  },
  watch: {
      value: function(){
        this.setObjectFromValue();
      },
      dataModelObject: function(){
          this.dataModel = this.dataModelObject ? this.dataModelObject[this.fieldValue] : null;
      }
  },
  methods: {
      close: function(){
          this.toggle();
      },
      cancel: function(){
          this.setObjectFromValue();
          this.close();
      },
      apply: function(){
          this.$emit("confirm", this.dataModel);
          this.close();
      },
      checkValidateResult: function($event){
          this.invalid = !$event.result;
      },
      setObjectFromValue: function(){
          this.label = this.fieldLabel ? this.fieldLabel : this.fieldValue;
          this.dataModel = this.value;
          var index = -1;
          this.choices.some(function(obj, i){
              if(obj[this.fieldValue] == this.value){
                  index = i;
                  return true;
              }
              return false;
          }, this);
          this.dataModelObject = index == -1 ? null : this.choices[index];
      }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/dynamic/popoverWrapper/SelectorModifier.vue?20174a70